/* eslint-disable */

export const protobufPackage = "squareup.authz_engines";
export let PolicyProtectedAction = /*#__PURE__*/function (PolicyProtectedAction) {
  PolicyProtectedAction[PolicyProtectedAction["ACTION_UNSPECIFIED"] = 0] = "ACTION_UNSPECIFIED";
  PolicyProtectedAction[PolicyProtectedAction["LINK_DEBIT_CARD"] = 1] = "LINK_DEBIT_CARD";
  PolicyProtectedAction[PolicyProtectedAction["CREATE_SQUARE_CHECKING_ACCOUNT"] = 2] = "CREATE_SQUARE_CHECKING_ACCOUNT";
  PolicyProtectedAction[PolicyProtectedAction["ORDER_SQUARE_DEBIT_CARD"] = 3] = "ORDER_SQUARE_DEBIT_CARD";
  PolicyProtectedAction[PolicyProtectedAction["CREATE_ACH_TRANSFER"] = 4] = "CREATE_ACH_TRANSFER";
  PolicyProtectedAction[PolicyProtectedAction["SCA_ACTION"] = 5] = "SCA_ACTION";
  PolicyProtectedAction[PolicyProtectedAction["SCA_VERIFICATION_ATTEMPT"] = 6] = "SCA_VERIFICATION_ATTEMPT";
  PolicyProtectedAction[PolicyProtectedAction["COMPLETE_LOGIN"] = 7] = "COMPLETE_LOGIN";
  PolicyProtectedAction[PolicyProtectedAction["LOGIN"] = 8] = "LOGIN";
  PolicyProtectedAction[PolicyProtectedAction["MERCHANT_REACTIVATION"] = 9] = "MERCHANT_REACTIVATION";
  PolicyProtectedAction[PolicyProtectedAction["IDDASH_EDIT_WORKFLOW"] = 10] = "IDDASH_EDIT_WORKFLOW";
  PolicyProtectedAction[PolicyProtectedAction["RISK_BASED_STEP_UP_ACTION"] = 11] = "RISK_BASED_STEP_UP_ACTION";
  PolicyProtectedAction[PolicyProtectedAction["BITCOIN_WITHDRAWAL"] = 12] = "BITCOIN_WITHDRAWAL";
  PolicyProtectedAction[PolicyProtectedAction["SQUARE_BANKING_TRANSFERS"] = 13] = "SQUARE_BANKING_TRANSFERS";
  PolicyProtectedAction[PolicyProtectedAction["SQUARE_PAYROLL"] = 14] = "SQUARE_PAYROLL";
  PolicyProtectedAction[PolicyProtectedAction["SQUARE_BILLPAY"] = 15] = "SQUARE_BILLPAY";
  PolicyProtectedAction[PolicyProtectedAction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return PolicyProtectedAction;
}({});
export let DenyCause = /*#__PURE__*/function (DenyCause) {
  DenyCause[DenyCause["UNKNOWN"] = 0] = "UNKNOWN";
  DenyCause[DenyCause["UNAUTHENTICATED"] = 1] = "UNAUTHENTICATED";
  DenyCause[DenyCause["INSUFFICIENT_PERMISSIONS"] = 2] = "INSUFFICIENT_PERMISSIONS";
  DenyCause[DenyCause["INSUFFICIENT_AUTHENTICATION"] = 3] = "INSUFFICIENT_AUTHENTICATION";
  DenyCause[DenyCause["SCA_ATTEMPTS_EXCEEDED_LIMIT"] = 4] = "SCA_ATTEMPTS_EXCEEDED_LIMIT";
  DenyCause[DenyCause["BLOCKED_BY_RISK"] = 5] = "BLOCKED_BY_RISK";
  DenyCause[DenyCause["ACH_AMOUNT_EXCEEDED_LIMIT"] = 6] = "ACH_AMOUNT_EXCEEDED_LIMIT";
  DenyCause[DenyCause["DEVICE_NOT_SUPPORTED"] = 7] = "DEVICE_NOT_SUPPORTED";
  DenyCause[DenyCause["ACCOUNT_OWNER_SANCTIONED"] = 8] = "ACCOUNT_OWNER_SANCTIONED";
  DenyCause[DenyCause["SECURE_CONTACT_METHOD_SANCTIONED"] = 9] = "SECURE_CONTACT_METHOD_SANCTIONED";
  DenyCause[DenyCause["BENEFICIAL_OWNER_OR_ROLE_SANCTIONED"] = 10] = "BENEFICIAL_OWNER_OR_ROLE_SANCTIONED";
  DenyCause[DenyCause["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
  return DenyCause;
}({});

/** Add data as needed here */

/**
 * This top-level object holds all information required to evaluate the login policy.
 * This is designed this way to reduce the burden of the policy caller to know which specific
 * policy to run against, while providing separation of different types of sessions within the input
 * to avoid cluttering a single object.
 */

/**
 * This MerchantReactivation object holds data that is used to evaluate the merchant reactivation
 * policy. legal_entity_token is optional and only supplied if this policy
 * is called by roster-rails. Providing this optional fields reduces round-trip calls to roster.
 */

/**
 * Holds information required to evaluate the risk based step-up auth policy, which is designed to
 * be generically used and not require any route-specific fields.
 */

/**
 * We want one top-level object that holds internal action-scoped objects. Even
 * in a world where we store common data in (or otherwise immediately accessible to) AuthzEngines,
 * there will likely always be some request contextual data used for evaluations that
 * make sense for the client to provide. Ideally as we get closer to that world, the size
 * and complexity of this request object shrinks.
 */

/** RouteContext contains metadata about the route that is being authorized against */